<template>
  <div>
    <b-toast
      id="toast-register"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img :src="imgMjeRegistro" style="margin-right: 10px; margin-top: -2px" />
      {{ messageRegisterStudent }}
    </b-toast>
    <b-breadcrumb>
      <!--to="/dashboard"-->
      <b-breadcrumb-item active>{{ $t("my-account.title") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <input type="tel" id="hiddeValues" v-show="false" />
    <div class="d-flex" v-if="student">
      <div class="card mr-3">
        <div class="p-3 text-center" style="width: 205px">
          <div class="content-photo text-center">
            <b-avatar
              :src="urlPhoto"
              size="145px"
              style="background: #b7b8bd"
              id="avatarPerson"
            ></b-avatar>
            <input
              type="file"
              ref="file"
              style="display: none"
              accept="image/*"
              @change="handleFile"
            />
            <div @click="$refs.file.click()" v-show="flagEdit" class="camera">
              <icon name="camera" />
            </div>
          </div>
          <div class="mt-4">
            <a href="/student/account" class="link blue">{{
              $t("my-account.change-password")
            }}</a>
          </div>
        </div>
      </div>
      <div class="card w-100" style="flex: 1">
        <div style="padding: 32px 36px">
          <b-row class="account-data">
            <b-col>
              <!-- Names -->
              <b-form-row>
                <b-col>
                  <b-form-group :label="$t('my-account.name')">
                    <p v-if="!flagEdit">{{ student.firstName }}</p>
                    <b-form-input
                      v-else
                      v-model="formStudent.firstName"
                      :placeholder="$t('my-account.name')"
                      required
                      v-bind:class="{ error: $v.formStudent.firstName.$error }"
                      @blur="$v.formStudent.firstName.$touch()"
                    >
                    </b-form-input>
                    <span class="error-input">{{
                      validationMsgRegistro($v.formStudent.firstName)
                    }}</span>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group :label="$t('my-account.last-name')">
                    <p v-if="!flagEdit">{{ student.lastName }}</p>
                    <b-form-input
                      v-else
                      v-model="formStudent.lastName"
                      :placeholder="$t('my-account.last-name')"
                      required
                      v-bind:class="{ error: $v.formStudent.lastName.$error }"
                      @blur="$v.formStudent.lastName.$touch()"
                      >>
                    </b-form-input>
                    <span class="error-input">{{
                      validationMsgRegistro($v.formStudent.lastName)
                    }}</span>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <!-- Email & DOB -->
              <b-form-row>
                <!-- Email -->
                <b-col>
                  <b-form-group :label="$t('my-account.email')">
                    <p v-show="!flagEdit">{{ student.email }}</p>
                    <b-form-input
                      v-show="flagEdit"
                      type="email"
                      v-model="formStudent.email"
                      :placeholder="$t('my-account.email')"
                      required
                      v-bind:class="{ error: $v.formStudent.email.$error }"
                      @blur="$v.formStudent.email.$touch()"
                    >
                    </b-form-input>
                    <span class="error-input">{{
                      validationMsgRegistro($v.formStudent.email)
                    }}</span>
                  </b-form-group>
                </b-col>

                <!-- Phone -->
                <b-col>
                  <div class="mb-0 form-group">
                    <label>{{ $t("my-account.phone") }}</label>
                    <div class="d-flex align-items-center" v-if="!flagEdit">
                      <div class="mr-2 iti__flag" :class="'iti__' + flajImg" />
                      <p>
                        +{{ student.extension_Phone }} {{ student.phoneNumber }}
                      </p>
                    </div>
                    <div class="d-flex">
                      <section
                        style="width: 80px; margin-right: 8px; min-width: 80px"
                        v-show="flagEdit"
                      >
                        <b-form-input
                          type="tel"
                          id="input-telefono"
                          required
                          v-bind:class="{
                            error: $v.formStudent.phoneNumber.$error,
                          }"
                          @blur="$v.formStudent.phoneNumber.$touch()"
                        >
                        </b-form-input>
                      </section>
                      <b-form-input
                        v-show="flagEdit"
                        type="tel"
                        v-model="formStudent.phoneNumber"
                        class="px-2"
                        required
                        v-bind:class="{
                          error: $v.formStudent.phoneNumber.$error,
                        }"
                        @blur="$v.formStudent.phoneNumber.$touch()"
                      >
                      </b-form-input>
                    </div>
                    <span class="error-input">{{
                      validationMsgRegistro($v.formStudent.phoneNumber)
                    }}</span>
                  </div>
                </b-col>
              </b-form-row>
              <b-form-row>
                <!-- DOB -->
                <b-col>
                  <b-form-group
                    class="mb-0"
                    :label="$t('my-account.date-birth')"
                  >
                    <p v-show="!flagEdit">{{ formStudent.strBirthDate }}</p>
                    <b-input-group v-show="flagEdit" class="datepicker-group">
                      <b-form-input
                        v-model="formStudent.strBirthDate"
                        :class="{ error: $v.formStudent.strBirthDate.$error }"
                        :placeholder="$t('my-account.date-birth')"
                        :value="$v.formStudent.strBirthDate.$model"
                        @blur="$v.formStudent.strBirthDate.$touch()"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-form-datepicker
                          button-only
                          :max="max"
                          right
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                          }"
                          :locale="langLocal"
                          @focusin.native="$v.formStudent.strBirthDate.$touch()"
                          @input="SetDateFormat"
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-input-group>
                    <span class="error-input">{{
                      validationMsgRegistro($v.formStudent.strBirthDate)
                    }}</span>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <!-- Edit -->
              <button
                v-if="!flagEdit"
                type="button"
                class="btn btn-primary mt-3"
                @click="toggleEdit(true)"
              >
                {{ $t("reusables.edit-2") }}
              </button>
              <div class="d-flex mt-4" v-if="flagEdit">
                <button
                  type="button"
                  class="btn btn-danger mr-4"
                  @click="toggleEdit(false)"
                >
                  {{ $t("reusables.cancel") }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="$v.formStudent.$invalid || flagClick"
                  @click="registerStudent"
                  :class="{ loading: isLoading }"
                >
                  {{ $t("reusables.save") }}
                </button>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";
import axios from "axios";
import imgMjeExito from "@/assets/img/ico-check.png";
import imgMjeError from "@/assets/img/ico-equis.png";
import { IMAGENES } from "@/assets/js/appConstants";
// Map intl-tel-input country names → API country names when they differ.
const COUNTRY_NAME_OVERRIDES = {
  "North Macedonia": "Macedonia",
};
const formRegisterMessages = {
  required: function () {
    return this.$t("validations.formRegisterMessages.required");
  },
  email: function () {
    return this.$t("validations.formRegisterMessages.email");
  },
  flagEmailEnUso: function () {
    return this.$t("validations.formRegisterMessages.flagEmailEnUso");
  },
  minLength: function ({ $params }) {
    return this.$t("validations.formRegisterMessages.minLength", {
      nro: $params.minLength.min,
    });
  },
  maxLength: function ({ $params }) {
    return this.$t("validations.formRegisterMessages.maxLength", {
      nro: $params.maxLength.max,
    });
  },
  alphaWithSpaces: function () {
    return this.$t("validations.formRegisterMessages.alphaWithSpaces");
  },
  numeric: function () {
    return this.$t("validations.formRegisterMessages.numeric");
  },
};

export default {
  components: {},
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    //console.log("maxDate: ",maxDate)
    return {
      lang: localStorage.getItem("lang") || "es",
      flagClick: false,
      urlPhoto: IMAGENES.PHOTO_STUDENT_DEFAULT,
      flagEdit: false,
      student: null,
      photo: null,
      max: maxDate,
      isLoading: false,
      listCountries: [],
      formStudent: null,
      messageRegisterStudent: "",
      iti: null,
      listIntlCountries: [],
      imgMjeRegistro: imgMjeExito,
      flajImg: "",
      langLocal: "es",
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(value) {
        this.$store.commit("mutateUser", value);
      },
    },
  },
  validations: {
    formStudent: {
      firstName: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50),
        alphaWithSpaces(value) {
          return /^[A-zÀ-ú\s]*$/.test(value);
        },
      },
      lastName: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(60),
        alphaWithSpaces(value) {
          return /^[A-zÀ-ú\s]*$/.test(value);
        },
      },
      email: {
        required,
        email,
        flagEmailEnUso(value) {
          if (value === "" || !this.$v.formStudent.email.email) return true;

          return new Promise((resolve, reject) => {
            return baseInstanceAxios
              .get(
                `${this.apiURL}/resources/PersonsStudents/ExistsEmailByStudents?Email=${value}&Id=${this.user.id}&FlagStudent=true`
              )
              .then((response) => {
                resolve(!response.data.return);
              })
              .catch((error) => {
                reject(error);
              });
          });
        },
      },
      /*extension_Phone: {
                required,
                numeric
            },*/
      phoneNumber: {
        required,
        numeric,
      },
      strBirthDate: {
        required,
      },
    },
  },
  created() {
    //console.log("lang: ",this.lang);
    this.langLocal = this.lang;
  },
  mounted() {
    this.getInformation();
    this.getCountries();
  },
  methods: {
    syncCountryId() {
      if (!this.iti || !this.listCountries.length) return;
      const selectedName = this.iti.getSelectedCountryData().name;
      if (!selectedName) return;
      const normalize = (s) =>
        s
          .replace(/\s*\(.*$/, "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .trim();
      const normalized = normalize(
        COUNTRY_NAME_OVERRIDES[selectedName] || selectedName
      );
      const found = this.listCountries.find(
        (c) => normalize(c.descripcion) === normalized
      );
      this.formStudent.countryId = found ? found.id : null;
      console.log("[CountryId]", {
        selectedName,
        matched: found || null,
        countryId: this.formStudent.countryId,
      });
    },
    onCountryChange() {
      this.syncCountryId();
    },
    validationMsgRegistro: validationMessage(formRegisterMessages),
    getListIntlCountries() {
      //Temporal => GH
      let input = document.getElementById("hiddeValues");
      let itil = intlTelInput(input);
      this.listIntlCountries = itil.countries;
      let country = this.listIntlCountries.find(
        (x) => x.dialCode == this.student.extension_Phone
      );
      this.flajImg = country.iso2;
      itil.destroy();
      input.remove();
    },
    SetDateFormat: function (value) {
      console.log("value: ", value);
      let dateFormat = this.$moment(value, "YYYY-MM-DD").format("MM/DD/YYYY");
      if (this.lang == "es") {
        dateFormat = this.$moment(value, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      console.log("dateFormat: ", dateFormat);
      this.formStudent.strBirthDate = dateFormat;
    },
    toggleEdit(state) {
      //this.$bvToast.show("toast-register");
      this.flagEdit = state;

      if (!state) {
        this.urlPhoto = this.student.photo;
        this.formStudent = this.getFormatData(this.student);
        this.iti.destroy();
      } else {
        //console.log("this.flagEdit: ",this.flagEdit)
        let country = this.listIntlCountries.find(
          (x) => x.dialCode == this.student.extension_Phone
        );
        const input = document.querySelector("#input-telefono");
        this.iti = intlTelInput(input, {
          initialCountry: country ? country.iso2 : "pe",
          preferredCountries: ["PE", "US"],
          separateDialCode: true,
        });
        input.addEventListener("countrychange", this.onCountryChange);
        this.syncCountryId();
      }
    },
    getInformation() {
      let flag = this.lang == "es" ? true : false;
      let params = {
        personStudentId: this.user.personStudentId,
        flagLanguage: flag,
      };

      baseInstanceAxios
        .get(`${this.apiURL}/Resources/PersonsStudents/GetInformation`, {
          params,
        })
        .then((response) => {
          if (response.data != null && response.data.entity != null) {
            this.student = response.data.entity.person;
            if (this.student.photo) {
              this.urlPhoto = this.student.photo;
            } else {
              this.student.photo = this.urlPhoto;
            }

            this.formStudent = this.getFormatData(response.data.entity.person);
            this.getListIntlCountries();
          }
        });
    },
    getFormatData(data) {
      let strBirthDate = "";
      if (data.strBirthDate) {
        strBirthDate =
          data.strBirthDate.split("-")[1] +
          "/" +
          data.strBirthDate.split("-")[0] +
          "/" +
          data.strBirthDate.split("-")[2];
        if (this.lang == "es") {
          strBirthDate = data.strBirthDate.split("-").join("/");
        }
      }

      console.log("strBirthDate: ", strBirthDate);
      let newData = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        extension_Phone: data.extension_Phone,
        phoneNumber: data.phoneNumber,
        strBirthDate: strBirthDate,
        address: data.address,
        countryId: data.countryId,
        country: {
          description: data.country.description,
        },
        photo: data.photo,
        city: data.city,
      };

      return newData;
    },
    handleFile(event) {
      this.photo = null;
      for (var i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        this.urlPhoto = URL.createObjectURL(file);
        this.photo = file;
        break;
      }
    },
    getCountries() {
      let flag = this.lang == "es" ? true : false;
      baseInstanceAxios
        .get(
          `${this.apiURL}/Resources/Countries/ListCountries?flagLenguage=${flag}`
        )
        .then((response) => {
          if (response.data != null && response.data.list) {
            this.listCountries = response.data.list;
            this.syncCountryId();
          }
        });
    },
    registerStudent() {
      this.flagClick = true;
      if (!this.isLoading) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.isLoading = true;

        let birthDate = this.$moment(
          this.formStudent.strBirthDate,
          "MM-DD-YYYY"
        ).toDate();
        if (this.lang == "es") {
          birthDate = this.$moment(
            this.formStudent.strBirthDate,
            "DD-MM-YYYY"
          ).toDate();
        }

        const model = Object.freeze({
          Id: this.user.id,
          FirstName: this.formStudent.firstName,
          LastName: this.formStudent.lastName,
          Email: this.formStudent.email,
          Extension_Phone: this.iti.selectedCountryData.dialCode,
          PhoneNumber: this.formStudent.phoneNumber,
          BirthDate: birthDate,
          Address: "",
          CountryId: this.formStudent.countryId,
          City: this.formStudent.city,
          UserModified: this.formStudent.email,
        });

        const formData = new FormData();
        formData.append("File", this.photo);
        formData.append("ModelStr", JSON.stringify(model));
        axios({
          method: "POST",
          url: `${this.apiURL}/Resources/Persons/UpdateInformation`,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + this.$store.state.authToken,
          },
        })
          .then((response) => {
            //console.log("response: ",response)
            if (response.data != null && response.data.return) {
              this.formStudent.extension_Phone = this.iti.selectedCountryData.dialCode;
              this.student = this.getFormatData(this.formStudent);

              let jsonUser = {
                age: this.user.age,
                birthDate: this.user.birthDate,
                email: this.user.email,
                firstName: this.user.firstName,
                groupScheduleStundentId: this.user.groupScheduleStundentId,
                id: this.user.id,
                lastName: this.user.lastName,
                personStudentId: this.user.personStudentId,
                personsTypeId: this.user.personsTypeId,
                photo: this.user.photo,
                strFullName: this.user.strFullName,
                timeZone: this.user.timeZone,
                timeZoneName: this.user.timeZoneName,
              };

              jsonUser.firstName = this.formStudent.firstName;
              jsonUser.lastName = this.formStudent.lastName;
              jsonUser.strFullName = `${this.formStudent.firstName} ${this.formStudent.lastName}`;
              jsonUser.email = this.formStudent.email;

              if (response.data.entity != null) {
                jsonUser.age = parseInt(response.data.entity.strAge, 10);
                jsonUser.photo = response.data.entity.photo;
              }

              this.$store.dispatch("updateUserAction", jsonUser);

              //if(!this.photo)
              this.iti.destroy();
              this.messageRegisterStudent = this.$t(
                "mjesRegistro.mjeActualizacionExito"
              );
              this.imgMjeRegistro = imgMjeExito;
              this.$bvToast.show("toast-register");
              this.flagEdit = false;
              this.flajImg = this.iti.selectedCountryData.iso2;
            } else {
              this.messageRegisterStudent = this.$t(
                "mjesRegistro.mjeActualizacionError"
              );
              this.imgMjeRegistro = imgMjeError;
              this.$bvToast.show("toast-register");
            }
            this.isLoading = false;
            this.flagClick = false;
          })
          .catch(function (error) {
            console.log(error);
            this.messageRegisterStudent = this.$t(
              "mjesRegistro.mjeActualizacionError"
            );
            this.imgMjeRegistro = imgMjeError;
            this.$bvToast.show("toast-register");
            this.isLoading = false;
            this.flagClick = false;
          });
      }
    },
  },
};
</script>

<style lang="scss">
.iti__flag {
  background-image: url("/images/flags.png");
}
.account-data label {
  margin-bottom: 6px;
}
#avatarPerson .b-avatar-img {
  margin: auto;
}
</style>
